import * as yup from "yup";

export const InsentiveSchema = yup.object().shape({
  //
  product: yup.string(),
  sellsType: yup.string().required("Required"),
  preGstAmount: yup.number().when("sellsType", {
    is: (sellsType) => sellsType === "physical site inspection",
    then: (s) =>
      s
        .required("Required")
        .max(10000, "Maximum amount for physical site inspection is 10,000"),
    otherwise: (s) => s.required("Required").min(1, "Minimum amount is 1"),
  }),
  actualSIAmount: yup.number().when("sellsType", {
    is: (sellsType) => sellsType === "physical site inspection",
    then: (s) => s.required("Required"),
  }),
  leadName: yup.string().required("Required"),
  leadId: yup.string().required("Lead not selected"),
  contact_number: yup.string().required("Lead not selected"),
  paidStatus: yup.string(),
  incentiveDescription: yup.string().required("Required"),
  revenueApproved: yup.string(),
  paymentMode: yup.string().required("Payment mode is required"),
  paymentReceipt: yup.mixed().when("paymentMode", {
    is: (paymentMode) => paymentMode !== "cash",
    then: (s) => s.required("Required"),
  }),

  paymentDate: yup.string().required("Payment date is required"),
  lead_owner: yup.string(),
});
